class WordDimension {
  constructor() {
    this.defaultHeight = this.getDefaultHeightSlow("text");
    this.widthForUnknownChars = 8; // manually estimated
    this.widths = [];
    let s =
      " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~öäüÄÜÖéèà";
    s.split("").forEach(e => {
      this.widths[e] = this.getWidthSlow(e);
    });
  }

  calculateHeightFast(text, expectedWidth) {
    // https://stackoverflow.com/questions/17648900/truncate-text-based-on-pixel-width-in-javascript-without-html-elements
    let len = text
      .split("")
      .reduce(
        (acc, element) =>
          acc + (this.widths[element] || this.widthForUnknownChars),
        0
      );
    let estimatedHeight = Math.ceil(len / expectedWidth) * this.defaultHeight;
    return estimatedHeight;
  }
  getWidthSlow(text) {
    // http://blog.bripkens.de/2011/06/html-javascript-calculate-text-dimensions/
    let div = document.createElement("div");
    div.style.display = "inline-block";
    div.textContent = text;
    document.body.appendChild(div);
    let width = div.offsetWidth;
    div.parentNode.removeChild(div);
    return width;
  }
  getDefaultHeightSlow(text) {
    // http://blog.bripkens.de/2011/06/html-javascript-calculate-text-dimensions/
    let div = document.createElement("div");
    div.style.display = "inline-block";
    div.textContent = text;
    document.body.appendChild(div);
    let height = div.offsetHeight;
    div.parentNode.removeChild(div);
    return height;
  }

  getHeight(text, expectedWidth) {
    return this.calculateHeightFast(text, expectedWidth);
  }
}

export default WordDimension;



// WEBPACK FOOTER //
// ./src/search-unified/WordDimension.js